import { render, staticRenderFns } from "./iSpringPresentationList.vue?vue&type=template&id=f106ab54&"
import script from "./iSpringPresentationList.vue?vue&type=script&lang=js&"
export * from "./iSpringPresentationList.vue?vue&type=script&lang=js&"
import style0 from "./iSpringPresentationList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports